import { Box } from "@mui/material";
import React from "react";
import PageTitle from "../base/PageTitle";
import UsersView from "../views/Users/UsersView";

interface Props {}

const UsersPage: React.FC<Props> = (props) => {
  return (
    <Box>
      <PageTitle title="Users" />
      <UsersView />
    </Box>
  );
};

export default UsersPage;
